<template>
  <div class="mt-3">
    <table class="b2b-grid b2b-grid--collapse is-compact" qaid="order-details-sku-grid">
      <thead class="b2b-grid__header">
        <th
          v-for="header in getColumns(sectionKey)"
          :key="header.label"
          class="b2b-grid__cell b2b-grid__head"
          :class="[{'whitespace-nowrap': header.key !== 'etaDate'}, header.cssClasses]"
          :data-type="header.key === 'etaDate' ? 'eta-date' : false"
          v-html="header.label"
        />
      </thead>

      <tbody>
        <template v-for="(item, itemIndex) in paginatedData">
          <account-order-details-backordered-item
            :key="itemIndex"
            :base-properties="baseProperties"
            :headers="getColumns(sectionKey)"
            :item="item"
            :item-index="itemIndex"
            :selectable="false"
          />
        </template>
      </tbody>
    </table>

    <div class="grid-x grid-margin-x mb-5">
      <div class="cell medium-6 large-8">
        <pagination
          v-if="pageCount > 1"
          ref="pagination"
          :page-number="pageNumber"
          :page-count="pageCount"
          @page-change="pageChange"
          @prev-page="prevPage"
          @next-page="nextPage"
        />
      </div>
      <div class="cell medium-6 large-4">
        <div v-if="!consumerFriendlyMode" v-cloak class="block-list text-base">
          <div class="block-list__item w-full" qaid="backordered-section-subtotal">
            <span v-html="bp('orderSubtotal')" />
            <span v-html="subtotal" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from '../../mixins/pagination';
import {mapGetters} from 'vuex';

export default {
  mixins: [pagination],
  props: {
    orderData: {
      type: Object,
      default: () => {},
    },
    size: {
      type: Number,
      required: false,
      default: ACC.allocatedItemsPageSize || 50,
    },
    warehouse: {
      type: Object,
      default: () => {},
    },
    shipmentInfo: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    sectionKey: {
      type: String,
      default: '',
    },
  },

  inject: [],

  data() {
    return {
      listData: this.items,
      pageSize: this.size,
      addPrice: String,
    };
  },
  computed: {
    ...mapGetters('backend', ['consumerFriendlyMode']),
    subtotal() {
      return this.orderData ? this.orderData.subTotals[this.sectionKey]?.price?.formattedValue : '';
    },
  },

  methods: {
    getColumns() {
      // The "Backordered" shouldn't have the Allocated or Cancel Date columns
      return this.headers.filter(this.filterColumns);
    },
    filterColumns(column) {
      if (this.sectionKey === 'notAllocatedItems') {
        if (column.key === 'quantityAllocatedOrShipped' || column.key === 'cancelDate') return false;
      }
      if (this.sectionKey === 'allocatedItems') {
        if (column.key === 'etaDate') return false;
      }
      if (this.consumerFriendlyMode && (column.key === 'unitPrice' || column.key == 'lineSubtotal')) return false;
      return true;
    },
  },
};
</script>
